import { Button, ButtonGroup } from "@material-ui/core";
import { useState } from "react";

const ToggleButtons = ({ buttons = [], callback }) => {
  const [state, toggle] = useState(0);

  const onClick = index => {
    toggle(index);
    !!callback && callback(index);
  };
  return (
    <ButtonGroup
      data-testid="toggle-button-group"
      color="primary"
      aria-label="outlined primary button group"
    >
      {buttons.map((button, index) => {
        const { name } = button;
        return (
          <Button
            variant={state === index ? "contained" : "outlined"}
            onClick={() => onClick(index)}
            key={"toggle-button-" + name}
            id={"toggle-button-" + name}
          >
            {name}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default ToggleButtons;
